import React, { Component } from 'react';
import AvgPlayspace from './playspace';
import AvgClassSpace from './classroom-space';

class AvgSpaceComparison extends Component {
  render() {
    const { data, chartName } = this.props;
    return (
      <div className="playspace-classroom-comparison">
        <div className="row">
          <div className="col" style={{ marginRight: '4px' }}>
            <h3 className="mbm">Classroom space per student</h3>
            <hr />
            <AvgClassSpace data={data} chartName={chartName} />
          </div>
          <div className="col" style={{ marginLeft: '4px' }}>
            <h3 className="mbm">Play space per student</h3>
            <hr />
            <AvgPlayspace data={data} chartName={chartName} />
          </div>
        </div>
      </div>
    );
  }
}

export default AvgSpaceComparison;



// WEBPACK FOOTER //
// ./src/components/AvgSpaceComparison.js